// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1ePQs","content":"Consent_content__1o_EF","footer":"Consent_footer__Sn_JE"};